import { render, staticRenderFns } from "./SavedRxListItem.vue?vue&type=template&id=95098972&scoped=true"
import script from "./SavedRxListItem.vue?vue&type=script&lang=ts"
export * from "./SavedRxListItem.vue?vue&type=script&lang=ts"
import style0 from "./SavedRxListItem.vue?vue&type=style&index=0&id=95098972&prod&lang=scss&scoped=true"
import style1 from "./SavedRxListItem.vue?vue&type=style&index=1&id=95098972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95098972",
  null
  
)

export default component.exports